import { environment } from 'src/environments/environment';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { Observable } from 'rxjs';
import { EnterpriseCityModel } from './../../models/management/enterprise-city.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseCityService {

  constructor(private _httpClient: HttpClient) { }
  getAllEnterpriseCity(): Observable<Array<EnterpriseCityModel>> {
    return this._httpClient.get<Array<EnterpriseCityModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.GetAllEnterpriseCities}`);
  }

  getAllEnterpriseCitiesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.GetAllEnterpriseCitiesWithPagination}`,
      filters, { params: params }
    );
  }

  getColumnsForConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.GetColumnsForConsultation}`);
  }

  getEnterpriseCityById(enterpriseCityId: number): Observable<EnterpriseCityModel> {
    return this._httpClient.get<EnterpriseCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.GetEnterpriseCityById}/${enterpriseCityId}`);
  }

  createEnterpriseCity(enterpriseCityContractModel: EnterpriseCityModel): Observable<EnterpriseCityModel> {
    return this._httpClient.post<EnterpriseCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.CreateEnterpriseCity}`,
      enterpriseCityContractModel);
  }

  updateEnterpriseCity(enterpriseCityContractModel: EnterpriseCityModel): Observable<EnterpriseCityModel> {
    return this._httpClient.put<EnterpriseCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.UpdateEnterpriseCity}`,
      enterpriseCityContractModel);
  }

  deleteEnterpriseCity(enterpriseCityId: number): Observable<EnterpriseCityModel> {
    return this._httpClient.delete<EnterpriseCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.DeleteEnterpriseCity}/${enterpriseCityId}`);
  }

  deleteSomeDetails(enterpriseCityIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.DeleteSomeDetailsAsync}`,
      enterpriseCityIds);
  }

  exportEnterpriseCitiesConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.ExportEnterpriseCitiesConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getEnterpriseCityByKeys(enterpriseId: number, cityId: number): Observable<EnterpriseCityModel> {
    return this._httpClient.get<EnterpriseCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.GetEnterpriseCityByKeys}/${enterpriseId}/${cityId}`);
  }

  getEnterpriseCityByEnterpriseId(enterpriseId: number): Observable<Array<EnterpriseCityModel>> {
    return this._httpClient.get<Array<EnterpriseCityModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.enterpriseCity.GetEnterpriseCityByEnterpriseId}/${enterpriseId}`);
  }
}
